import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import * as S from './MainHeader.styles';

export const MainHeader: React.FC = ({ children }) => {
  const { keycloak } = useKeycloak();

  return <S.Header className={keycloak.authenticated ? 'loggedIn' : 'loggedOut'}>{children}</S.Header>;
};
